<!-- 基本信息 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header   flex flexColumn">
        <div class="head-title borderB">
          <div class="text">疗愈生活</div>
        </div>
        <div class="headSearch Fs14">
          <div class="headSearch-left">
            <div class="Search-condition">
              <div class="form-data group">
                <span>手机号码：</span>
                <el-input v-model="SearchForm.tel" size="mini" placeholder="" clearable></el-input>
              </div>
              <div class="form-data group">
                <span>客户姓名：</span>
                <el-input v-model="SearchForm.name" size="mini" placeholder="" clearable></el-input>
              </div>
              <div class="form-data group">
                <span>记录名称：</span>
                <el-input v-model="SearchForm.reportName" size="mini" placeholder="" clearable></el-input>
              </div>
              <div class="form-data group">
                <span>指导医生：</span>
                <el-input v-model="SearchForm.tester" size="mini" placeholder="" clearable></el-input>
              </div>
            </div>
            <div class="Search-condition">
              <div class="form-data group">
                <span>创建时间：</span>
                <el-date-picker size="mini" v-model="SearchForm.time" type="date" placeholder="选择日期"></el-date-picker>
              </div>
              <div class="form-data group">
                <el-button @click="SearchBut" round type="primary" size="mini">搜索</el-button>
                <el-button @click="reportAddBut" icon="el-icon-plus" round type="primary" size="mini">新增记录</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content" style="margin-top: 50px;">
        <el-table
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="ReportList.list"
          style="width: 100%">
          <el-table-column prop="id" label="#"> </el-table-column>
          <el-table-column prop="tel" label="手机号"> </el-table-column>
          <el-table-column prop="name" label="客户姓名"> </el-table-column>
          <el-table-column prop="reportName" label="记录名称"> </el-table-column>
          <el-table-column prop="reportNum" label="记录编号"> </el-table-column>
          <el-table-column prop="tester" label="指导医生"> </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              <span>{{ scope.row.createTime | filterTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="reportClick(scope.row)" type="primary" size="small">详情</el-button>
              <el-button @click="reportDeleteClick(scope.row)" type="danger" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="Pagination flex">
          <div class="text">
            <span>共{{ ReportList.total }}条记录，</span>
            <span class="pageNum">{{ ReportList.pageNum }}</span>
            <span>/{{ ReportList.pages }}页</span>
          </div>
          <el-pagination
            v-if="ReportList !== ''"
            @current-change="handleCurrentChange"
            :current-page.sync="ReportList.pageNum"
            :page-size="ReportList.pageSize"
            layout="prev, pager, next, jumper"
            :total="ReportList.total">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 新增记录 -->
    <el-dialog title="记录编辑" width="800px" :visible.sync="reportDialogVisible" :append-to-body="true" custom-class="outer-dialog" :close-on-click-modal="false">
      <el-form ref="reportForm" :model="reportForm" :rules="rules" label-width="100px">
        <el-card class="box-card">
          <el-row>
            <el-col :span="12">
              <el-form-item label="所属人员" prop="personId">
                <el-select v-model="reportForm.personId" placeholder="请选择" filterable @change="bindPersonChange">
                  <el-option v-for="item in personOptions"
                    :key="item.id" :label="item.name + '/' +item.tel" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户姓名" prop="name">
                <el-input v-model="reportForm.name" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="记录名称" prop="reportName">
                <el-input v-model="reportForm.reportName" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="记录编号" prop="reportNum">
                <el-input v-model="reportForm.reportNum" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="指导医生" prop="tester">
                <el-input v-model="reportForm.tester" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="指导建议" prop="note">
                <el-input v-model="reportForm.note" placeholder="请输入内容" type="textarea" :rows="3"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="box-card" style="margin-top: 10px;">
          <div slot="header" class="clearfix">
            <el-tag type="danger" effect="plain">记录附件</el-tag>
            <el-button @click="uploadClick" type="primary" size="small" round style="float: right;">上传</el-button>
            <el-table :data="reportImgList" border style="width: 100%; margin-top: 20px;"
              :header-cell-style="{ background: '#f5f7fa !important' ,color:'#909399 !important'}">
              <el-table-column prop="imgName" label="文件名称" min-width="2"></el-table-column>
              <el-table-column prop="imgUrl" label="点击预览" min-width="1">
                <template slot-scope="scope">
                  <div v-if="scope.row.imgUrl.endsWith('.pdf')">
                    <a :href="scope.row.imgUrl" target="_blank" style="font-weight: 800; color: #33ab9e">点击预览</a>
                  </div>
                  <div class="demo-image__preview" v-else>
                    <el-image style="width: 100px; height: 100px" :src="scope.row.imgUrl" :preview-src-list="srcList"></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column min-width="1" label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" icon="el-icon-delete" @click="tableDelete(scope.$index, scope.row)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reportDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="reportUpdateBut">确 定</el-button>
      </div>
      <!-- 弹出框 -->
      <el-dialog :visible.sync="uploadDilaogVisible" :modal="false" width="500px" custom-class="inner-dialog" :close-on-click-modal="false">
        <el-form ref="uploadForm" :model="uploadForm" :rules="rules" label-width="80px">
          <el-form-item label="文件名" prop="imgName">
            <el-input v-model="uploadForm.imgName" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="选取文件" prop="imgUrl">
              <el-upload action="#" :limit="10" :file-list="fileList" multiple
              :http-request="uploadSectionFile" :on-exceed="handleExceed"
              :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
              <el-button size="mini" type="danger" icon="el-icon-upload"></el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="uploadDilaogVisible = false">取 消</el-button>
          <el-button type="primary" @click="uploadInBut">确 定</el-button>
        </div>
      </el-dialog>
    </el-dialog>


  </div>
</template>

<script>
import { apiGetHealingPage, apiUpdateHealing, apiDeleteHealing, apiGetHealingDtl } from '@/api/clientManage'
import { apiGetSimpleAlertPerson } from '@/api/alertManage'
import { apiUploadByBase64 } from '@/api/uploading'
let _self
export default {
  name: '',
  props: [''],
  data() {
    return {
      ReportList: '', // 记录列表page
      ReportTmplList: '',// 记录模板列表list
      pages: {
        page: 1, // 页数
        size: 50
      },
      SearchForm: {
        tel: '',
        name: '',
        reportName: '',
        tester: '',
        time: '',
      },
      // 记录
      personOptions: [],
      personSelect: {},
      reportForm: {},
      reportDialogVisible: false,
      uploadDilaogVisible: false,
      reportContentData: [],
      lastDoTime: null,
      reportNameSelect: '',
      reportNameOptions: [{label: '出院记录', value: '出院记录'},
      {label: '体能十二经络综合评估', value: '体能十二经络综合评估'},
      {label: '康养小结', value: '康养小结'},
      {label: '营养状况评估', value: '营养状况评估'}
      ],
      // 上传
      uploadForm: {},
      fileList: [],
      imageUrl: '',
      dialogImageUrl: '',
      reportImgList: [],
      srcList: [],
      
      rules: {
        personId: [
          { required: true, message: '请选择所属人员', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入客户姓名', trigger: 'blur' },
        ],
        reportName: [
          { required: true, message: '请输入记录名称', trigger: 'blur' },
        ],
        reportNum: [
          { required: true, message: '请输入记录编号', trigger: 'blur' },
        ],
        // tester: [
        //   { required: true, message: '请输入指导医生', trigger: 'blur' },
        // ],
      },
    }
  },

  components: {  },

  computed: {},

  beforeMount() {},

  mounted() {
    _self = this
    this.GetReportList()
  },

  methods: {
    // 搜索
    SearchBut() {
      this.GetReportList()
    },
    // 列表-服务信息
    reportClick(row) {
      this.reportForm = {};
      this.reportImgList = [];
      this.srcList = [];
      this.reportNameSelect = '';
      apiGetHealingDtl({
        id: row.id
      }).then(res => {
        if(res.status == 0) {
          this.reportForm = res.data;
          if(this.reportForm.urls == null) {
          } else {
            let urlArr = this.reportForm.urls.split(",");
            let nameArr = this.reportForm.unames.split(",");
            urlArr.forEach( (url, index) => {
              this.reportImgList.push({imgName: nameArr[index], imgUrl: urlArr[index]});
            });
            this.calSrcList();
          }
          this.reportDialogVisible = true;
          this.GetPersonList();
        }
      });
    },
    reportDeleteClick(row){
        this.$confirm('确认删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            apiDeleteHealing({id: row.id}).then(res => {
              if (res.status === 0) {
                this.$message({message: '删除成功', type: 'success'});
                this.GetReportList();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
      },
    // 分页
    handleCurrentChange(val) {
      this.pages.page = val
      console.log(`当前页: ${val}`)
      this.GetReportList()
    },
    // 接口
    // 获取基本用户的列表
    GetReportList() {
      let createTimeLong = 0;
      if(this.SearchForm.createTime) {
        createTimeLong = this.SearchForm.createTime.getTime();
      }
      apiGetHealingPage({
        tel: this.SearchForm.tel,
        name: this.SearchForm.name,
        reportName: this.SearchForm.reportName,
        tester: this.SearchForm.tester,
        createTimeLong: createTimeLong,
        // doTime: this.SearchForm.doTime,
        // time: this.SearchForm.time,
        page: this.pages.page,
        pageSize: this.pages.size
      }).then(res => {
        if (res.status === 0) {
          this.ReportList = res.data
          console.log('ReportList', this.ReportList)
        }
      })
    },
    GetPersonList() {
      apiGetSimpleAlertPerson({}).then( res => {
        if(res.status == 0) {
          this.personOptions = res.data;
        }
      });
    },

    // 记录
    clearForm() {
      this.reportForm = {};
      this.reportContentData = [];
      this.fileList = [];
      this.reportImgList = [];
      this.srcList = [];
      this.reportNameSelect = '';
    },
    reportAddBut() {
      this.clearForm();
      this.reportDialogVisible = true;
      this.GetPersonList();
    },
    reportUpdateBut(row) {
      this.$refs['reportForm'].validate(valid => {
        if (valid) {
          let urlArr = [];
          let nameArr = [];
          this.reportImgList.forEach(f=>{
            urlArr.push(f.imgUrl);
            nameArr.push(f.imgName);
          });
          this.reportForm.urls = urlArr.join(',');
          this.reportForm.unames = nameArr.join(',');
          delete this.reportForm.createTime;
          apiUpdateHealing(this.reportForm).then(res => {
            if (res.status === 0) {
              this.$message({message: '保存成功', type: 'success'});
              this.reportDialogVisible = false;
              this.clearForm();
              this.GetReportList();
            } else {
              this.$message({message: '上传失败', type: 'error'});
            }
          });
        }
      });
    },
    bindPersonChange() {
      this.personOptions.forEach( po=>{
        if(this.reportForm.personId == po.id) {
          this.reportForm.name = po.name;
          return;
        }
      });
    },
    bindReportNameChange() {
      this.reportNameOptions.forEach( rn=>{
        if(this.reportNameSelect == rn.label) {
          this.$set(this.reportForm, 'reportName', rn.value);
          return;
        }
      });
    },

    uploadClick() {
      this.fileList = [];
      this.uploadForm = {};
      let rn = this.reportForm.reportName;
      if(rn) {
        this.$set(this.uploadForm, 'imgName', rn);
      }
      this.uploadDilaogVisible = true;
      console.log("上传");
    }, 
    tableDelete(index, row){
      // 删除模板项目
      this.$confirm('确认删除？')
          .then(_ => {
            this.reportImgList.splice(index, 1);
            this.calSrcList();
          })
          .catch(_ => {});
    },
    uploadInBut() {
      let imgName = this.uploadForm.imgName;
      if(imgName == null || imgName == undefined || imgName == '') {
        this.$message.error('请填写文件名');
        return;
      }
      if(this.fileList == null || this.fileList.length == 0) {
        this.$message.error('请至少上传一个文件');
        return;
      }
      if(this.fileList.length > 1) {
        this.fileList.forEach((fl, index) => {
          let tmpName = imgName + '-' + (index+1);
          this.reportImgList.push({imgName: tmpName, imgUrl: fl.url});
        });
      } else {
        this.reportImgList.push({imgName: imgName, imgUrl: this.fileList[0].url});
      }
      this.calSrcList();
      // let fl = this.fileList[0];
      this.uploadDilaogVisible = false;
      this.fileList = [];
      this.uploadForm = {};
    },
    // 附件上传
    uploadSectionFile(params, file1) {
      // if (this.fileList.length > 0) {
      //   this.$message.error('最高可上传一个图片')
      //   return
      // }
      let that = this;
      const file = params.file
      const fileType = file.type
      let ft = "jpg";
      if(fileType.includes('pdf')) {
        ft = 'pdf';
      }
      // const isImage = fileType.indexOf('image') !== -1
      // const isLt2M = file.size / 1024 / 1024 < 2
      // 这里常规检验，看项目需求而定
      // if (!isImage) {
      //   this.$message.error('只能上传图片格式png、jpg、gif!')
      //   return
      // }
      // if (!isLt2M) {
      //   this.$message.error('只能上传图片大小小于2M')
      //   return
      // }
      // 将图片转成base64
      const reader = new FileReader()
      reader.readAsDataURL(file) // 开始转
      reader.onload = function(e) {
        // const _self = this
        // this.result // 这个就是base64编码了
        this.imageUrl = this.result.split('base64,')[1]
        apiUploadByBase64({
          base64: this.imageUrl,
          path: 'HealingReport',
          suffix: ft
        }).then(res => {
          if (res.status === 0) {
            // this.$message({message: '上传成功', type: 'success'});
            let name = new Date().getTime() + "-" + file.name
            let url = that.baseImage + res.data;
            that.fileList.push({name: name, url: url});
          }
          console.log("flist", that.fileList)
        })
      }
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
      },
    // 删除文件之前的钩子
    handleRemove(file) {
      this.fileList.forEach((f, i)=>{
        if(file.name == f.name) {
          console.log('i:',i);
          this.fileList.splice(i, 1);
          return;
        }
      });
    },
    // 文件超出个数限制时的钩
    handleExceed(file, fileList) {
      console.log(fileList)
      console.log(this.fileList)
      this.$message.error('最高可上传一个图片')
    },
    calSrcList() {
      this.srcList = [];
      this.reportImgList.forEach(ri=>{
        if(!ri.imgUrl.endsWith(".pdf")) {
          this.srcList.push(ri.imgUrl);
        }
      });
    }


  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.outer-dialog {
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
}
 
.inner-dialog {
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
}
.flex {
  display: flex;
}
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  padding: 0 10px;
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    height: 92px;
    .headSearch {
      .headSearch-left {
        width: 85%;
        float: left;
        .form-data {
          // span {
          //   width: 90px;
          // }
          /deep/ .el-date-editor,
          .el-input,
          .el-cascader {
            width: 200px;
          }
        }
      }
      .headSearch-right {
        width: 10%;
        float: right;
      }
    }
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 214px);
    /deep/ .el-table {
      overflow: auto;
      height: calc(100vh - 272px);
    }
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
.dialog {
}
</style>
